
<div class="row">
    <div class="col-sm-6">
      <h4>Add Stock Requirement</h4>
      <p>Kitchen Stock  / Add Stock Requirement</p>
    </div>
    <div class="col-sm-6 mt-3">   
    </div>
  </div>
  
  <div class="card mt-3 card-boarder-radius"  [ngClass]="{'dark-bg' : isDark }">
    <div class="row m-3">
      <div class="col-md-6">
        <div class="form-group">
          <label for="search" class="col-form-label">Search</label>  
          <div class="input-group">
                <div class="input-group-text bg-transparent border border-right-0"><i class="fa fa-search" [ngClass]="{'dark-bg' : isDark }"></i></div>
            <input [(ngModel)]="searchKey" (keyup)="applyFilter()" autocomplete="off" [ngClass]="{'dark-bg' : isDark }" class="form-control py-2 border   border-right-0 " type="text" placeholder="Search">
              <button class="btn  border border-left-0" type="button">
                  <i *ngIf="searchKey" (click)="onSearchClear()" class="fa fa-close" [ngClass]="{'dark-bg' : isDark }"></i>
              </button>         
           </div>   
          </div>
        </div>
  
  
        <div class="col-md-4 offset-2 mt-4 text-center">
            <button class="btn btn-warning  ml-2 text-white" (click)="clearOrderBtnClick()"><i class="far fa-trash-alt"></i> Clear</button>     
            <button class="btn btn-success  ml-1 text-white" (click)="proceedOrderBtnClick()"><i class="fa fa-shopping-cart m-1"></i> <span class="badge bg-danger mb-1">{{itemCount}}</span> Checkout</button>  
      </div>
  
    </div>
  </div>
  
  <div class="row mt-3">
    <div class="col-12">
    <div class="card card-boarder-radius" [ngClass]="{'dark-bg' : isDark ,'dark-border-color' : isDark }">                  
     <div class="card-body">
      <div class="col-12 table-responsive scrollable" id="offerListReport"  #cusBalReport>
        <table class="table" [ngClass]="{'dark-bg' : isDark }">
          <thead>
          <tr>                                
            <th>Item</th>
            <th class="text-right">UnitCost</th>  
            <th>Unit</th>
            <th>Qty Bal</th>           
            <th>Action</th>                     
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of filteredFinalList; let i = index">    
          
            <td>{{item.Name}}</td>
            <td class="text-right">{{item.UnitCost |  number:'1.2-3'}}</td>
            <td>{{item.Unit}}</td>
            <td>{{item.QtyBal }}</td>
          
            <td>
              <button *ngIf="!item.filled" class="btn btn-primary btn-sm ml-1 text-white" (click)="openAddOrderItemButtonClick(item)" data-toggle="deleteTooltip" data-placement="bottom" title="Add"><i class="fa fa-plus"></i></button>    
              <button  *ngIf="item.filled" class="btn btn-danger btn-sm  ml-1  text-white"  (click)="removeOrderItem(item.Id)" data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="fa fa-close"></i></button>              
          </td> 
          </tr>                                              
          </tbody>
        </table>
      </div>
      <!-- /.col -->
     </div>
    </div>
    </div>
    </div>
  
    <div class="row no-print">
      <div class="col-12">   
        <!-- <button type="button" printSectionId="cusBalReport" [useExistingCss]="true" ngxPrint  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>   -->
         <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('print')"  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>      
        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="exportexcel()"  class="btn btn-default float-right"><i class="fa fa-file-excel-o" style="color:green"></i> Excel</button>      
         <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('open')"  class="btn btn-default float-right"><i class="fa fa-file-pdf-o" style="color:red"></i> PDF</button>                                                                                                                                                              
      </div>
    </div>
  
  
  
  
  
  
  
  
